module.exports = __webpack_public_path__ + "img/chargingpoint-charging-hub-definitive.fbe9053c.png";